'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = undefined;

var _Main2 = require('./Main');

var _Main3 = _interopRequireDefault(_Main2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Main = _Main3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/index.js
// module id = 1813
// module chunks = 0